import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Master} from '../../../../../admin/models/master.interface';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {FormBuilder, FormControl} from '@angular/forms';
import {MatSelectChange} from '@angular/material/select';
import {REGIONS} from '../../../../../constants/constants';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-composition-filters',
  templateUrl: './composition-filters.component.html',
  styleUrls: ['./composition-filters.component.scss']
})
export class CompositionFiltersComponent implements OnInit {

  regions = REGIONS;

  @Input()
  years!: number[];
  @Input()
  categories!: Master[];
  @Input()
  countryCategory!: string;

  searchForm = this.formBuilder.group({
    year: [''],
    categoryType: ['NEW'],
    detailLevel: [],
    b2bB2c: [],
    member: [],
    region: [''],
    order: [],
    displayUnits: ['ABSOLUTE'],
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }
  get categoryTypeControl(): FormControl {
    return this.searchForm.get('categoryType') as FormControl;
  }
  get detailLevelControl(): FormControl {
    return this.searchForm.get('detailLevel') as FormControl;
  }
  get b2bB2cControl(): FormControl {
    return this.searchForm.get('b2bB2c') as FormControl;
  }
  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }
  get regionControl(): FormControl {
    return this.searchForm.get('region') as FormControl;
  }
  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();
  @Output()
  loadCategories: EventEmitter<string> = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      categoryType: this.categoryTypeControl.value,
      detailLevel: this.detailLevelControl.value,
      b2bB2c: this.b2bB2cControl.value,
      member: this.memberControl.value,
      region: this.regionControl.value,
      order: this.orderControl.value,
      displayUnits: this.searchForm.controls.displayUnits.value,
    };
    this.search.emit(search);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.categoryTypeControl.setValue('NEW');
    this.detailLevelControl.setValue(null);
    this.b2bB2cControl.setValue(null);
    this.memberControl.reset();
    this.regionControl.reset();
    this.orderControl.setValue(null);
    this.search.emit({startYear: this.years[0], categoryType: 'NEW', displayUnits: 'ABSOLUTE'});
  }

  getCategories(event: MatSelectChange): void {
    if (event?.value) {
      this.loadCategories.emit(event.value);
    }
  }

}
